/* eslint-disabled */

export default class AdditionalInfoExtend {


  constructor (object?: any) {
  }

  postConstruct () {
  }
}
